export const EXTERNAL_IP_HOST_STATISTICS_LIST_SET = 'EXTERNAL_IP_HOST_STATISTICS_LIST_SET'
export const EXTERNAL_IP_HOST_STATISTICS_LIST_REQ = 'EXTERNAL_IP_HOST_STATISTICS_LIST_REQ'
export const EXTERNAL_IP_HOST_STATISTICS_LIST_SUCCESS = 'EXTERNAL_IP_HOST_STATISTICS_LIST_SUCCESS'
export const EXTERNAL_IP_HOST_STATISTICS_LIST_ERROR = 'EXTERNAL_IP_HOST_STATISTICS_LIST_ERROR'
export const EXTERNAL_IP_HOST_STATISTICS_LIST_RESET_STATUS = 'EXTERNAL_IP_HOST_STATISTICS_LIST_RESET_STATUS'

export const HRLY_EXTERNAL_IP_STATISTICS_LIST_SET = 'HRLY_EXTERNAL_IP_STATISTICS_LIST_SET'
export const HRLY_EXTERNAL_IP_STATISTICS_LIST_REQ = 'HRLY_EXTERNAL_IP_STATISTICS_LIST_REQ'
export const HRLY_EXTERNAL_IP_STATISTICS_LIST_SUCCESS = 'HRLY_EXTERNAL_IP_STATISTICS_LIST_SUCCESS'
export const HRLY_EXTERNAL_IP_STATISTICS_LIST_ERROR = 'HRLY_EXTERNAL_IP_STATISTICS_LIST_ERROR'
export const HRLY_EXTERNAL_IP_STATISTICS_LIST_RESET_STATUS = 'HRLY_EXTERNAL_IP_STATISTICS_LIST_RESET_STATUS'

export const TOP_EXTERNAL_IP_STATISTICS_LIST_SET = 'TOP_EXTERNAL_IP_STATISTICS_LIST_SET'
export const TOP_EXTERNAL_IP_STATISTICS_LIST_REQ = 'TOP_EXTERNAL_IP_STATISTICS_LIST_REQ'
export const TOP_EXTERNAL_IP_STATISTICS_LIST_SUCCESS = 'TOP_EXTERNAL_IP_STATISTICS_LIST_SUCCESS'
export const TOP_EXTERNAL_IP_STATISTICS_LIST_ERROR = 'TOP_EXTERNAL_IP_STATISTICS_LIST_ERROR'
export const TOP_EXTERNAL_IP_STATISTICS_LIST_RESET_STATUS = 'TOP_EXTERNAL_IP_STATISTICS_LIST_RESET_STATUS'

export const BOTTOM_EXTERNAL_IP_STATISTICS_LIST_SET = 'BOTTOM_EXTERNAL_IP_STATISTICS_LIST_SET'
export const BOTTOM_EXTERNAL_IP_STATISTICS_LIST_REQ = 'BOTTOM_EXTERNAL_IP_STATISTICS_LIST_REQ'
export const BOTTOM_EXTERNAL_IP_STATISTICS_LIST_SUCCESS = 'BOTTOM_EXTERNAL_IP_STATISTICS_LIST_SUCCESS'
export const BOTTOM_EXTERNAL_IP_STATISTICS_LIST_ERROR = 'BOTTOM_EXTERNAL_IP_STATISTICS_LIST_ERROR'
export const BOTTOM_EXTERNAL_IP_STATISTICS_LIST_RESET_STATUS = 'BOTTOM_EXTERNAL_IP_STATISTICS_LIST_RESET_STATUS'

export const NEW_EXTERNAL_IP_STATISTICS_LIST_SET = 'NEW_EXTERNAL_IP_STATISTICS_LIST_SET'
export const NEW_EXTERNAL_IP_STATISTICS_LIST_REQ = 'NEW_EXTERNAL_IP_STATISTICS_LIST_REQ'
export const NEW_EXTERNAL_IP_STATISTICS_LIST_SUCCESS = 'NEW_EXTERNAL_IP_STATISTICS_LIST_SUCCESS'
export const NEW_EXTERNAL_IP_STATISTICS_LIST_ERROR = 'NEW_EXTERNAL_IP_STATISTICS_LIST_ERROR'
export const NEW_EXTERNAL_IP_STATISTICS_LIST_RESET_STATUS = 'NEW_EXTERNAL_IP_STATISTICS_LIST_RESET_STATUS'



// WEBPACK FOOTER //
// ./src/store/modules/statistics/external-ip-statistics.type.js